import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HeartHandshake, Clock, ChevronRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import { fmtTime } from "@/components/PageHeader";
import api from "@/lib/api";

// Member dashboard: today's volunteer shifts; each drops off once it ends (not dismissible).
export default function VolunteerTodayCard() {
  const [items, setItems] = useState([]);
  const [now, setNow] = useState(Date.now());
  useEffect(() => { api.get("/volunteers/my/today").then(({ data }) => setItems(data.items || [])).catch(() => {}); }, []);
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 60000); return () => clearInterval(t); }, []);
  const live = items.filter((s) => Date.parse(s.ends_at) > now);
  if (!live.length) return null;
  return (
    <Link to="/member/schedule?tab=volunteers" className="mb-4 block" data-testid="volunteer-today-card">
      <Card className="flex items-center gap-4 border-teal-200 bg-teal-50/60 p-4 shadow-sm rounded-xl transition-transform hover:-translate-y-0.5 hover:shadow-md animate-fade-in-up">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-teal-600 text-white"><HeartHandshake className="h-5 w-5" /></span>
        <div className="min-w-0 flex-1">
          <p className="text-xs font-bold uppercase tracking-wider text-teal-700">You're volunteering today</p>
          {live.map((s) => (
            <p key={s.id} className="mt-0.5 text-sm text-slate-700" data-testid={`volunteer-today-${s.id}`}>
              <span className="font-semibold text-slate-800">{s.sheet_title}</span>
              <span className="mx-1.5 inline-flex items-center gap-1 text-slate-500"><Clock className="h-3.5 w-3.5" />{fmtTime(s.start_time)} – {fmtTime(s.end_time)}</span>
              {s.label && <span className="text-slate-500">· {s.label}</span>}
            </p>
          ))}
        </div>
        <ChevronRight className="h-5 w-5 shrink-0 text-teal-600" />
      </Card>
    </Link>
  );
}
